import { render, staticRenderFns } from "./pharmacie.vue?vue&type=template&id=33c1bce8&scoped=true&"
import script from "./pharmacie.vue?vue&type=script&lang=js&"
export * from "./pharmacie.vue?vue&type=script&lang=js&"
import style0 from "./pharmacie.vue?vue&type=style&index=0&id=33c1bce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c1bce8",
  null
  
)

export default component.exports